import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import MuiStep from '@mui/material/Step';
import { styled } from '@mui/material/styles';
import MuiStepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Check from '@mui/icons-material/Check';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    borderTopWidth: '1px',
    borderTopStyle: 'dashed',
    minWidth: '2rem',
  },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
}));

function StepIconRenderer({ isActive, isCompleted, icon, isError }) {
  if (isCompleted && !isError) {
    return (
      <Box
        sx={(theme) => ({
          width: '33px',
          height: '33px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        })}
      >
        <Check sx={{ fontSize: '1.2rem' }} />
      </Box>
    );
  }

  if (isActive && !isError) {
    return (
      <Box
        sx={(theme) => ({
          width: '33px',
          height: '33px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: `1.5px solid  ${theme.palette.primary.main}`,
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
        })}
      >
        <Typography sx={{ fontSize: '1rem', fontWeight: 600 }}>{icon}</Typography>
      </Box>
    );
  }

  if (isError) {
    return (
      <Box
        sx={(theme) => ({
          width: '33px',
          height: '33px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: `1.5px solid ${theme.palette.error.main}`,
          borderRadius: '50%',
          backgroundColor: theme.palette.error.light,
        })}
      >
        <Typography sx={{ fontSize: '1rem', fontWeight: 600 }}>{icon}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={(theme) => ({
        width: '33px',
        height: '33px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1.5px solid ${theme.palette.action.disabled}`,
        borderRadius: '50%',
      })}
    >
      <Typography sx={{ fontSize: '1rem', fontWeight: 600 }}>{icon}</Typography>
    </Box>
  );
}

function QontoStepIcon(props) {
  const { active, completed, className, icon, isError } = props;

  return (
    <QontoStepIconRoot className={className}>
      <StepIconRenderer isActive={active} isCompleted={completed} isError={isError} icon={icon} />
    </QontoStepIconRoot>
  );
}

export const stepShape = {
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.node.isRequired,
  element: PropTypes.elementType,
  errorKey: PropTypes.arrayOf(PropTypes.string),
};

export default function Stepper({ steps, activeStep, errors }) {
  const allErrors = Object.keys(errors || {});
  let activeIndex = activeStep;

  if (activeIndex === -1) {
    activeIndex = steps.length;
  }

  return (
    <MuiStepper activeStep={activeIndex} connector={<QontoConnector />} orientation="horizontal">
      {steps.map((step, key) => {
        const isError = step.errorKey?.some((errorKey) => allErrors.includes(errorKey));

        return (
          <MuiStep key={step.key}>
            <StepLabel
              sx={(theme) => ({
                '& .MuiStepLabel-label': {
                  fontWeight: 600,
                  fontSize: '1rem',
                },
                '& .MuiStepLabel-label.Mui-completed': {
                  color: isError ? theme.palette.error.main : theme.palette.primary.main,
                },
              })}
              StepIconComponent={(p) => <QontoStepIcon {...p} isError={isError} />}
              StepIconProps={{
                completed: activeIndex > key,
                active: activeIndex === key,
              }}
            >
              {step.label}
            </StepLabel>
          </MuiStep>
        );
      })}
    </MuiStepper>
  );
}

Stepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape(stepShape)).isRequired,
  activeStep: PropTypes.number.isRequired,
  errors: PropTypes.object,
};
